import FormImageUploader from 'components/FormImageUploader/FormImageUploader';
import {
	CreateCategoryContext,
	ICreateCategoryContext,
} from 'modules/Menu/Category/CreateCategory/createCategoryState/createCategoryContext';
import React, { useContext } from 'react';
import InputFields from './components/InputFields';
import classNames from 'classnames';
import style from './CreationForm.module.scss';

const descriptionOfAspectRatio = {
	horizontal: {
		ratio: '13:8',
		optimalResolutions: {
			a: '208*128px',
			b: '416*256px',
		},
	},
	vertical: {
		ratio: '13:8',
		optimalResolutions: {
			a: '208*128px',
			b: '416*256px',
		},
	},
};

interface ICreationForm {
	isVisible: boolean;
}

const CreationForm: React.FC<ICreationForm> = ({ isVisible }) => {
	const { setFileId, fileId } = useContext<ICreateCategoryContext>(CreateCategoryContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const deletePhotoHandler = () => {
		setFileId(null);
	};

	return (
		<div className={containerClasses} data-test="CreationForm">
			<FormImageUploader
				containerClass={style.imageUploader}
				maxFileSizeMB={1}
				fileId={fileId}
				deletePhotoHandler={deletePhotoHandler}
				setFileId={setFileId}
				horizontalAspectRatio={208 / 128}
				verticalAspectRatio={208 / 128}
				descriptionOfAspectRatio={descriptionOfAspectRatio}
			/>
			<InputFields />
		</div>
	);
};

export default CreationForm;
